import { createContext, useContext } from '../../_snowpack/pkg/react.js';
import { QueryClient } from '../../_snowpack/pkg/react-query.js';
import AppStore from './app.store.js';
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      cacheTime: 0
    }
  }
});
const store = new AppStore();
const StoreContext = /*#__PURE__*/createContext(store);
const useStore = () => {
  return useContext(StoreContext);
};
export { queryClient, store, StoreContext, useStore };